import {combineReducers, createStore} from "redux";
import UserReducer from "./reducers/UserReducer";

export default createStore(
    combineReducers({
        userReducer: UserReducer,
    })
)
